import { useMutation } from "@tanstack/react-query";
import { SearchSingleCreateBodyDto } from "api/Api";
import { useGetApiClient } from "api/get-api-client";
import { useRecaptchaContext } from "contexts/recaptcha";
import { useAppDispatch, useAppSelector } from "store";
import { authNewSelectors } from "store/reducers/auth-new";
import { searchSinglePageActions } from "store/reducers/search-single-page";

const useApiSearchSingleCreate = () => {
  const apiClient = useGetApiClient();
  const dispatch = useAppDispatch();
  const isLoggedIn = useAppSelector(authNewSelectors.loggedInGet);
  const { tokenGet } = useRecaptchaContext();

  return useMutation({
    mutationFn: async (data: SearchSingleCreateBodyDto) => {
      if (!isLoggedIn) {
        data.recaptcha = await tokenGet("searchSingle");
      }

      return await apiClient.search.searchSingleCreate(data);
    },
    onSuccess: ({ data }) => {
      dispatch(searchSinglePageActions.openedSearchIdAdd(data.id));
      dispatch(searchSinglePageActions.searchQuerySet(""));
      dispatch(searchSinglePageActions.trackResultSearchIdAdd(data.id));
    },
  });
};

export default useApiSearchSingleCreate;
